module.exports = __webpack_public_path__ + "static/media/moo-fill.af328f7a.svg";